export default {
  'pricing.title': 'Options d\'Adhésion Exclusives',
  'pricing.subtitle': 'Choisissez le niveau d\'adhésion parfait pour répondre à vos désirs',
  'pricing.basic': 'Basique',
  'pricing.popular': 'Populaire',
  'pricing.elite': 'Élite',
  'pricing.no_ads': 'Sans publicités',
  'pricing.access_teaser': 'Accès au contenu privé teaser',
  'pricing.basic_messaging': 'Accès aux messages de base',
  'pricing.view_contacts': 'Voir les coordonnées des escorts',
  'pricing.get_started': 'Commencer',
  'pricing.all_teaser': 'Toutes les fonctionnalités Teaser',
  'pricing.client_verification': 'Vérification client incluse',
  'pricing.full_access': 'Accès complet à toutes les photos et vidéos',
  'pricing.leave_reviews': 'Laisser des avis après les rencontres',
  'pricing.priority_support': 'Support prioritaire',
  'pricing.subscribe_now': 'S\'abonner Maintenant',
  'pricing.all_regular': 'Toutes les fonctionnalités Standard',
  'pricing.vip_badge': 'Badge VIP sur le profil et les messages',
  'pricing.early_access': 'Accès anticipé aux nouvelles escorts',
  'pricing.vip_escorts': 'Accès aux escorts VIP uniquement',
  'pricing.discounted_rates': 'Tarifs réduits pour le contenu premium',
  'pricing.go_vip': 'Devenir VIP',
  'pricing.faq_title': 'FAQ sur la tarification',
  'pricing.faq.how_subscriptions': 'Comment fonctionnent les abonnements ?',
  'pricing.faq.how_subscriptions_answer': 'Les abonnements donnent accès à certaines fonctionnalités pendant la durée choisie...',
  'pricing.faq.payment_secure': 'Mon paiement est-il sécurisé ?',
  'pricing.faq.payment_secure_answer': 'Oui, nous utilisons Stripe pour traiter les paiements en toute sécurité...',
  'pricing.faq.refund': 'Puis-je obtenir un remboursement ?',
  'pricing.faq.refund_answer': 'Nous offrons des remboursements sous certaines conditions, veuillez consulter notre politique...',
  'pricing.faq.verification': 'Comment fonctionne la vérification ?',
  'pricing.faq.verification_answer': 'La vérification est un processus permettant de confirmer l\'identité...',
  'pricing.choose_plan': 'Choisissez Votre Plan',
  
  // New translations for subscription plan names and prices
  'subscription.teaser.title': 'Pink Teaser',
  'subscription.teaser.price': '4,99€/mois',
  'subscription.regular.title': 'Pink Regular',
  'subscription.regular.price': '19,99€/mois',
  'subscription.vip.title': 'Pink VIP',
  'subscription.vip.price': '100€/mois',
  
  // Additional translations for UI elements
  'pricing.privacy_title': 'Confidentialité Renforcée',
  'pricing.privacy_description': 'Fonctionnalités de confidentialité améliorées pour votre tranquillité d\'esprit.',
  'pricing.content_title': 'Contenu Exclusif',
  'pricing.content_description': 'Accédez à du contenu exclusif et des services premium non disponibles pour les utilisateurs gratuits.',
  'pricing.support_title': 'Support Prioritaire',
  'pricing.support_description': 'Support client prioritaire pour tous vos besoins.',
  'pricing.learn_more': 'En savoir plus',
  'pricing.see_examples': 'Voir des exemples',
  'pricing.contact_support': 'Contacter le support',
  'pricing.detailed_comparison': 'Comparaison détaillée',
  'pricing.feature': 'Fonctionnalité',
  'pricing.description': 'Description',
  
  // Feature descriptions
  'pricing.no_ads_description': 'Navigation sans publicités intrusives',
  'pricing.access_teaser_description': 'Aperçu du contenu privé des escorts',
  'pricing.basic_messaging_description': 'Possibilité d\'envoyer des messages de base',
  'pricing.view_contacts_description': 'Voir les informations de contact des escorts',
  'pricing.client_verification_description': 'Badge de vérification pour une confiance accrue',
  'pricing.full_access_description': 'Accès complet aux galeries privées',
  'pricing.leave_reviews_description': 'Possibilité de laisser des avis après rendez-vous',
  'pricing.priority_support_description': 'Assistance prioritaire en cas de besoin',
  'pricing.vip_badge_description': 'Badge VIP exclusif sur votre profil',
  'pricing.early_access_description': 'Accès anticipé aux nouveaux profils',
  'pricing.vip_escorts_description': 'Accès aux escorts réservées aux membres VIP',
  'pricing.discounted_rates_description': 'Tarifs préférentiels sur les services premium'
};
